import { useCallback } from 'react';
import { List } from 'foundations-components/transitional/components/List';
import { NestingStructureItemWrapper } from './NestingStructureItemWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const NestableList = ({
  items,
  renderItem: itemRenderer,
  getItemDepth,
  getPreviousItemDepth,
  getItemKey,
  indentSize,
  lineWeight,
  lineColor,
  endpointWidth
}) => {
  const getDepth = useCallback((item, index) => {
    if (getItemDepth) {
      return getItemDepth(item, index);
    } else if (typeof item === 'object' && 'depth' in item) {
      return Number(item.depth);
    }
    return 0;
  }, [getItemDepth]);
  const getPreviousDepth = useCallback((item, index) => {
    if (getPreviousItemDepth) {
      return getPreviousItemDepth(item, index);
    } else if (typeof item === 'object' && 'previousDepth' in item) {
      return Number(item.previousDepth);
    } else if (index > 0) {
      return getDepth(items[index - 1], index - 1);
    }
    return 0;
  }, [getPreviousItemDepth, getDepth, items]);
  const getKey = useCallback((item, index) => {
    if (getItemKey) {
      return getItemKey(item, index);
    } else if (typeof item === 'object' && 'id' in item) {
      return String(item.id);
    }
    return String(index);
  }, [getItemKey]);
  const renderItemContent = useCallback((item, index) => {
    if (itemRenderer) {
      return itemRenderer(item, index);
    } else if (typeof item === 'string') {
      return /*#__PURE__*/_jsx("span", {
        children: item
      });
    } else if (typeof item === 'object') {
      if ('label' in item && typeof item.label === 'string') {
        return /*#__PURE__*/_jsx("span", {
          children: item.label
        });
      } else if ('name' in item && typeof item.name === 'string') {
        return /*#__PURE__*/_jsx("span", {
          children: item.name
        });
      } else if ('text' in item && typeof item.text === 'string') {
        return /*#__PURE__*/_jsx("span", {
          children: item.text
        });
      }
    }
    return /*#__PURE__*/_jsx("span", {
      children: String(item)
    });
  }, [itemRenderer]);
  const renderItem = useCallback((item, index) => {
    const depth = getDepth(item, index);
    const previousDepth = getPreviousDepth(item, index);
    const key = getKey(item, index);
    return /*#__PURE__*/_jsx(NestingStructureItemWrapper, {
      depth: depth,
      endpointWidth: endpointWidth,
      indentSize: indentSize,
      lineColor: lineColor,
      lineWeight: lineWeight,
      previousDepth: previousDepth,
      children: renderItemContent(item, index)
    }, key);
  }, [getDepth, getPreviousDepth, getKey, indentSize, lineWeight, endpointWidth, lineColor, renderItemContent]);
  return /*#__PURE__*/_jsx(List, {
    wrapChildren: true,
    children: items.map(renderItem)
  });
};
NestableList.displayName = 'NestableList';